module.exports = __webpack_public_path__ + "img/pir-brick-horizontal.2b71feeb.svg";